<template>
  <!-- 黄埔大学生检查报告 -->
  <div v-if="model && model.huangPuUniversity">
    <div id="print_huangPuUniversity" class="page huangPuUniversity-page">
      <div style="display: flex;font-size: 23px;text-align: center;font-weight: 600;">
        <table style="width: 100%;border-collapse: collapse;border:none;letter-spacing: 5px;">
          <tbody>
            <tr style="width: 100%;border-collapse: collapse;border:none;">
              <td style="border-collapse: collapse;border:none;">{{ model.huangPuUniversity.reportName ? model.huangPuUniversity.reportName : "黄埔大学生检查报告" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table style="padding-left: 10px;text-align: left;width: 100%;margin-top:10px;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 35px;border:none;margin-top: 10px;">
            <td colspan="7" style="width: 45%;border:none;margin-top: 10px;">学校：<span>{{ model.huangPuUniversity.schoolName ? model.huangPuUniversity.schoolName : "" }}</span></td>
            <td colspan="3" style="width: 30%;border:none;margin-top: 10px;">班级：<span>{{ model.huangPuUniversity.className ? model.huangPuUniversity.className : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="text-align: center;width: 100%;border-collapse: collapse;border: 1px solid black;">
        <tbody>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">姓名</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.name ? model.huangPuUniversity.name : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">性别</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.sex ? model.huangPuUniversity.sex : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">年龄</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.age ? model.huangPuUniversity.age : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">身份证号</td><td colspan="6" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.idcard ? model.huangPuUniversity.idcard : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td rowspan="2" style="border-collapse: collapse;border: 1px solid black;">一般检查</td>
            <td style="border-collapse: collapse;border: 1px solid black;">身高</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.height ? model.huangPuUniversity.height : "" }}</span><span style="float:right;margin-right: 15px">cm</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">体重</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.weight ? model.huangPuUniversity.weight : "" }}</span><span style="float:right;margin-right: 15px">kg</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">血压</td>
            <td colspan="2" style="border-collapse: collapse;border: 1px solid black;">
              <span>{{model.huangPuUniversity.systolicPressure ? model.huangPuUniversity.systolicPressure : "" }}</span>/<span>{{model.huangPuUniversity.diastolicPressure ? model.huangPuUniversity.diastolicPressure : "" }}</span><span style="float:right;margin-right: 15px;">mmhg</span>
            </td>
            <td style="border-collapse: collapse;border: 1px solid black;">心率</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.pulseHeartRate ? model.huangPuUniversity.pulseHeartRate : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td rowspan="4" style="border-collapse: collapse;border: 1px solid black;">内科</td>
            <td style="border-collapse: collapse;border: 1px solid black;">心肺</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.lung ? model.huangPuUniversity.lung : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">神经系统</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.nervousSystem ? model.huangPuUniversity.nervousSystem : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td rowspan="2" style="border-collapse: collapse;border: 1px solid black;">腹部器官</td><td rowspan="2" colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.abdomen ? model.huangPuUniversity.abdomen : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">肝</td><td colspan="3" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.liver ? model.huangPuUniversity.liver : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">脾</td><td colspan="3" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.spleen ? model.huangPuUniversity.spleen : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="5" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.internalOder ? model.huangPuUniversity.internalOder : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td rowspan="3" style="border-collapse: collapse;border: 1px solid black;">外科</td>
            <td style="border-collapse: collapse;border: 1px solid black;">皮肤黏膜</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.skinMucousMembranes ? model.huangPuUniversity.skinMucousMembranes : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">头颈</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.headNeck ? model.huangPuUniversity.headNeck : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">淋巴结</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.lymphNode ? model.huangPuUniversity.lymphNode : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">甲状腺</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.thyroidGland ? model.huangPuUniversity.thyroidGland : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">脊柱</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.spine ? model.huangPuUniversity.spine : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">四肢关节</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.limbsJoints ? model.huangPuUniversity.limbsJoints : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">肛门生殖器</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.anogenitalRegion ? model.huangPuUniversity.anogenitalRegion : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">疝</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.hernia ? model.huangPuUniversity.hernia : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">其他</td><td style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.surgeryOder ? model.huangPuUniversity.surgeryOder : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td rowspan="3" style="width: 80px;border-collapse: collapse;border: 1px solid black;">眼科</td>
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">视力（裸眼）</td>
            <td rowspan="2" style="width: 80px;border-collapse: collapse;border: 1px solid black;">右</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.rightEyeVision ? model.huangPuUniversity.rightEyeVision : "" }}</span></td>
            <td rowspan="2" style="width: 80px;border-collapse: collapse;border: 1px solid black;">左</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.leftEyeVision ? model.huangPuUniversity.leftEyeVision : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">视力（矫正）</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.correctRightEyeVision ? model.huangPuUniversity.correctRightEyeVision : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.correctLeftEyeVision ? model.huangPuUniversity.correctLeftEyeVision : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">色觉</td><td colspan="4" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.colorVision ? model.huangPuUniversity.colorVision : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td rowspan="3" style="width: 80px;border-collapse: collapse;border: 1px solid black;">耳鼻喉科</td>
            <td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;">听力</td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;">右耳</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.rightEar ? model.huangPuUniversity.rightEar : "" }}</span></td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;">左耳</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.leftEar ? model.huangPuUniversity.leftEar : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">鼻</td><td colspan="2" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.nose ? model.huangPuUniversity.nose : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">嗅觉</td><td colspan="2" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.senseSmell ? model.huangPuUniversity.senseSmell : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">咽喉</td><td colspan="5" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.pharynx ? model.huangPuUniversity.pharynx : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td rowspan="3" style="width: 80px;border-collapse: collapse;border: 1px solid black;">口腔科</td>
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">面部</td><td colspan="5" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.face ? model.huangPuUniversity.face : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">口腔唇腭</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.cleftLipPalate ? model.huangPuUniversity.cleftLipPalate : "" }}</span></td>
            <td style="border-collapse: collapse;border: 1px solid black;">牙齿</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.teeth ? model.huangPuUniversity.teeth : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="border-collapse: collapse;border: 1px solid black;">是否口吃</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.stuttering ? model.huangPuUniversity.stuttering : "" }}</span></td>
            <td style="width: 120px;border-collapse: collapse;border: 1px solid black;">发声是否嘶哑</td><td colspan="2" style="border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.hoarse ? model.huangPuUniversity.hoarse : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">血常规</td><td colspan="6" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.bloodRoutineTest ? model.huangPuUniversity.bloodRoutineTest : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">肝功能</td><td colspan="6" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.liverFunction ? model.huangPuUniversity.liverFunction : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">DR胸部</td><td colspan="6" style="width: 120px;border-collapse: collapse;border: 1px solid black;"><span>{{ model.huangPuUniversity.dr ? model.huangPuUniversity.dr : "" }}</span></td>
          </tr>
          <tr style="line-height:50px;">
            <td colspan="2" style="width: 140px;float:left;margin-left: 5px;">检查结果及结论：</td>
            <td colspan="7" style="width: 100px;text-align:left;"><span>{{ model.huangPuUniversity.inspectionResults ? model.huangPuUniversity.inspectionResults : "" }}</span></td>
          </tr>
          <tr style="text-align:right;"><td colspan="7" style="padding-right: 35px;padding-top:30px;">（体检机构盖章）</td></tr>
          <tr>
            <td colspan="2" style="width: 100px;float: left;margin-left: 5px;">医生签名：</td><td colspan="1" style="text-align: right;"><img :src="model.huangPuUniversity.doctorSignature" style="height: 40px;width: 100px;object-fit: contain;" v-if="model.huangPuUniversity.doctorSignature"></td>
            <td colspan="5" style="text-align: right;padding-right: 35px;letter-spacing: 2.5px;"><span>{{ model.huangPuUniversity.physicalDate ? dayform(model.huangPuUniversity.physicalDate) : "年  月  日"}}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>

import {_huangPuUniversity} from "@/services/report/report";
export default {
  name: "huangPuUniversityReport",
  props: {
    physicalId:[String,Number],
    barCode:[String,Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        huangPuUniversity:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    };
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'huangPuUniversity'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'huangPuUniversity') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.huangPuUniversity(this.barCode);
      }
    },
    huangPuUniversity(barCode) {
      _huangPuUniversity({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        /*if(this.model.huangPuUniversity.barCodeImage){
          this.drawBase64ToCanvas(this.model.huangPuUniversity.barCodeImage);
        }*/
      })
    },
    drawBase64ToCanvas (base64String) {
      const canvas = this.$refs.barcodeImage;
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // 设置Canvas尺寸与图片一致
        canvas.width = img.width;
        canvas.height = img.height;
        // 绘制图片
        ctx.drawImage(img, 0, 0);
      };

      img.onerror = () => console.error("图片加载失败");
      img.src = base64String;
    },
    dayform(data, format){
      if (data!==null&&data!==''){
        return dayjs(data).format(format? format : "YYYY年MM月DD")
      }
      return  ""
    },
  }
}
</script>

<style lang="postcss" scoped>
@media print {
  .huangPuUniversity-page {
    page: huangPuUniversity-page; /* 绑定唯一命名 */
  }
  @page huangPuUniversity-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;margin:0 auto;padding-top:30px;padding-left:35px;padding-right:35px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff; font-size: 15px;}
.pastMedicalHistory::before{content: '√';color: red;position: relative;left: 15px;top: 5px;font-weight: 600;font-size: 20px;line-height: 24px;}

</style>

